import { render } from "./index copy.vue?vue&type=template&id=de2f483c&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"

import "./index copy.vue?vue&type=style&index=0&id=de2f483c&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2f483c"]])

export default __exports__